import type { DateTime } from "luxon";
import { createContext, useContext } from "react";
import type { DayItem, HoursSummaryEmployeeDayShift, NurseInShift } from "../../utils/models";

export type WeekViewContextType = {
	/** Data-week-indexed (Sun-aligned). Safe to index with `getDayIndexByDate`. */
	weekViewData: DayItem[];
	/** Visible-position-indexed (rotated by `viewStartDay`). Renderer use only — do NOT index by date. */
	visibleWeekViewData: DayItem[];
	costlyShiftsByDay: Map<string, NurseInShift[]>;
	shiftHoursById: Map<string, HoursSummaryEmployeeDayShift>;
	actualShiftIds: Set<string>;
	recentCallInsCounts: Record<number, number>;
	getPtoCost: (date: DateTime, nurseId: number) => number | undefined;
};

export const WeekViewContext = createContext<WeekViewContextType | null>(null);

export const useWeekViewContext = () => {
	const context = useContext(WeekViewContext);
	if (!context) throw new Error("useWeekViewContext must be used within a WeekViewContextProvider");
	return context;
};
